<template>
    <div>
      <OnboardingIndex
        :title="title"
        :submitButtonText="submitButtonText"
        :verification_running="verification_running"
        @submit="sign_up_function"
      >
        <template v-slot:form-content>
          <div v-if="sub_entity_context" class="alert alert-info text-xxs py-2 mb-2">
            You are registering under
            <strong>{{ sub_entity_context.parent_entity_name }}</strong>
            as
            <strong>{{ sub_entity_context.child_entity_type_name }}</strong>.
          </div>

          <div v-if="is_loading_context" class="alert alert-secondary text-xxs py-2 mb-2">
            <i class="fas fa-spinner fa-spin me-1"></i>
            Loading onboarding context...
          </div>

          <div class="row ">
          <div class="mb-1 text-xxs">
            <label>Select type</label>

              <select
                v-model="entity_type_id"
                class="form-select form-select-sm text-xs p-1 shadow-sm text-x"
                :disabled="Boolean(sub_entity_context)"
                required
              >
                <option value="" disabled>Select Entity Type</option>
                <option v-for="type in entity_type_list" :key="type.id" :value="type.id">
                  {{ type.name }}
                </option>
              </select>
            </div>

            <div class="col-md-6">
              <label for="first_name" class="text-xxs">First Name</label>
              <input
                type="text"
                class="form-control form-control-lg text-xxs bg-light py-2 pe-4 border-0"
                v-model="first_name"
                id="first_name"
                placeholder="Enter your first name"
                required
              />
            </div>
            <div class="col-md-6">
              <label for="last_name" class="text-xxs">Last Name</label>
              <input
                type="text"
                class="form-control form-control-lg text-xxs bg-light py-2 pe-4 border-0"
                v-model="last_name"
                id="last_name"
                placeholder="Enter your last name"
                required
              />
            </div>
          </div>

          <div class="mb-1">
            <label for="email" class="text-xxs">Email</label>
            <input
              type="text"
              class="form-control form-control-lg text-xxs bg-light py-2 pe-4 border-0"
              v-model="email"
              placeholder="Enter your email address"
              required
            />
          </div>

          <div class="mb-1">
            <label for="cell_number" class="text-xxs">Phone Number</label>
            <input
              type="text"
              class="form-control form-control-lg text-xxs bg-light py-2 pe-4 border-0"
              v-model="phone_number"
              maxlength="10"
              @keypress="validate_numbers"
              oninput="this.value = this.value.replace(/\D/g, '')"
              placeholder="Enter your phone number"
              required
            />
              <small
                v-if="phone_number && !validate_phone_number(phone_number)"
                class="text-danger p-2 text-xxs fw-bold d-block"
              >
                Please enter a valid 10-digit phone number
              </small>
              <small
                v-else
                class="text-danger p-2 text-xxs fw-bold d-none"
              >
              Please enter a valid phone number
              </small>
          </div>
          <!-- New Password Field -->
      <div class="mb-1 position-relative">
        <label for="password" class="text-xxs">New Password</label>
        <input
          :type="show_password ? 'text' : 'password'"
          class="form-control password form-control-lg text-xxs bg-light py-2 pe-4 border-0"
          v-model="password"
          id="password"
          placeholder="Enter your password"
          required
        />
        <i
          :class="show_password ? 'bi bi-eye' : 'bi bi-eye-slash'"
          class="position-absolute end-0 top-50 translate-middle-y-eye me-3 text-secondary cursor-pointer z-2"
          @click="toggle_password_visibility"
        ></i>
      </div>

      <!-- Confirm Password Field -->
      <div class="mb-1 position-relative">
        <label class="text-xxs">Confirm password</label>
        <input
          :type="show_confirm_password ? 'text' : 'password'"
          class="form-control password form-control-lg text-xxs bg-light py-2 pe-4 border-0"
          v-model="confirm_password"
          id="confirm_password"
          placeholder="Confirm your password"
          required
        />
        <i
          :class="show_confirm_password ? 'bi bi-eye' : 'bi bi-eye-slash'"
          class="position-absolute end-0 top-50 translate-middle-y-eye me-3 text-secondary cursor-pointer z-2"
          @click="toggle_confirm_password_visibility"
        ></i>
      </div>


        </template>

        <!-- Signup-specific elements -->
      <template v-slot:signup-content>
        <p class="mt-3 mb-0 text-xs">
          Already have an account?
          <a href="/" class="text-primary text-decoration-none fw-bold">Login here</a>
        </p>
      </template>


      </OnboardingIndex>
      <button
        class="btn btn-secondary-dark btn-sm rounded-small text-xxs shadow text-dark d-none"
        data-bs-toggle="modal"
        data-bs-target="#verify_account"
        ref ="trigger_modal_btn"
      >
      </button>
      <teleport to="body">
        <div class="modal fade" id="verify_account" tabindex="-1" aria-labelledby="verify_account_label" aria-hidden="true">
          <div class="modal-dialog modal-lg">
            <div class="modal-content bg-white rounded-3">
              <div class="modal-header border-bottom-0 custom-header text-white">
                <h5 class="modal-title text-xxs" id="verify_account_label">Account Verification</h5>
                <button ref ="trigger_close_modal_btn" type="button" class="btn-close " data-bs-dismiss="modal" aria-label="Close"></button>
              </div>

              <div class="modal-body py-5">

                <p>{{ verify_acc_message }}</p>

                <!-- Password Field -->
                <div class="mb-2 position-relative">
                  <label for="password" class="text-xxs">Password</label>
                  <input
                    :type="show_password ? 'text' : 'password'"
                    class="form-control form-control-lg text-xxs bg-light border-0 py-3 pe-5"
                    v-model="login_password"
                    id="password"
                    placeholder="Enter your password"
                    required
                  />
                  <i
                    :class="show_password ? 'bi bi-eye' : 'bi bi-eye-slash'"
                    class="position-absolute end-0 top-50 translate-middle-y-eye me-3 text-secondary cursor-pointer z-2"
                    @click="toggle_password_visibility"
                  ></i>
                </div>
                <div class="d-flex justify-content-center mt-4">
                  <button class="btn btn-secondary-dark btn-sm rounded-small text-xxs shadow text-dark"
                  @click="sign_up_function">Verify</button>
                </div>


              </div>
            </div>
          </div>
        </div>
      </teleport>

    </div>
  </template>

